import rightImg from "images/sectionhero.png";
import rightImg1 from "images/whychooseus.png";

import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";

import SectionHero3 from "components/SectionHero/SectionHero3";
import SectionHero from "containers/PageAbout/SectionHero";
import SectionHero2 from "containers/PageAbout/SectionHero2";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import { useEffect, useState } from "react";

import RentalPolicies from "components/RentalPolicies/RentalPolicies";
import girlpic from "images/girl.png";
import RentalOptions from "components/RentalOptions/RentalOptions";
import TransfersSection from "components/ReliableTransfer/TrasferSection";
import WhyChooseUS from "components/WhyChooseUS/WhyChooseUs";
import ServicesSection from "components/ServicesSection/ServiceSection";
import GirlSection from "./GirlSection";
import SprinterVansGallery from "components/SpiterVanGallery/SpiterVanGallery";

function PageHome3() {
  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  return (
    <>
      <div className="nc-PageHome3 relative overflow-hidden">
        <SectionHero3 className="" />

        <div className="container">
          <RentalOptions />
        </div>
        <div className="container relative" style={{ padding: "0px" }}>
          <div className="container relative py-16">
            <SectionGridFeaturePlaces />
          </div>
          <div className="container pt-16 space-y-16 ">
            <SectionHero
              rightImg={rightImg}
              heading="About Us"
              btnText=""
              subHeading={globalJson?.about_us_para}
            />
          </div>
          <div className="container pb-16  space-y-16 ">
            <ServicesSection />
          </div>
          <div className="container pt-16  space-y-16 ">
            <GirlSection
              rightImg={girlpic}
              heading="Girls' Night Out - Glam, Fun & Luxury!"
              btnText=""
              subHeading="Step into the ultimate girls' night experience! Whether you're celebrating a special occasion or just vibing with your besties, our luxury rides set the perfect mood."
            />
          </div>
          <div className="container py-16 space-y-16 ">
            <TransfersSection />
          </div>
          <div className="container ">
            <SprinterVansGallery />
          </div>
          <div className="container py-16 space-y-16 ">
            <div className="bg-[#B4B4B41A] rounded-2xl">
              <div className="relative py-16">
                <SectionClientSay uniqueClassName="PageAbout_" />
              </div>
            </div>
          </div>
          <div className="container py-16 lg:py-28 space-y-16 ">
            <SectionHero2
              rightImg={rightImg1}
              heading="Why Choose Us!"
              btnText=""
              subHeading="At Empire Motors Inc., we don’t just offer rentals—we create extraordinary experiences. From elite concierge services to high-performance motorsport vehicle rentals, we cater to those who demand the best. Whether you're chasing adrenaline on a rugged adventure or indulging in a private luxury getaway, we provide seamless service, top-tier safety, and an unforgettable ride tailored to your needs. Elevate every moment—book your journey today!"
            />
          </div>
        </div>
      </div>
      <div className="container relative py-16">
        <RentalPolicies />
      </div>
    </>
  );
}

export default PageHome3;
